import { openLink } from "../../../../../functions/functions";
import { formatDateWithTime } from "../dateHelpers";
import "./calendar.sass";

export default function Calendar({ 
  homeCalendarData = [],
  awayCalendarData = [],
  homeTeamName = "Equipo Local",
  awayTeamName = "Equipo Visitante",
}) {
  if (!homeCalendarData || !awayCalendarData || (homeCalendarData.length === 0 && awayCalendarData.length === 0)) {
    return (
      <div className="calendar-container">
        <div className="empty-message">No hay próximos partidos</div>
      </div>
    );
  }

  console.log(" data: ", homeCalendarData, " --- ", awayCalendarData)
  return (
    <div className="calendar-container">
      {/* Sección de partidos locales */}
      {homeCalendarData && homeCalendarData.length > 0 && (
        <div className="calendar-section">
          <h3 className="calendar-section-title">Partidos {homeTeamName}</h3>
          <div className="calendar-content">
            {homeCalendarData.map((match) => (
              <div key={match.id_juego} className="calendar-match" onClick={() => openLink(match.opta_event_url, true)}>
                <div className="match-date">
                  <span className="date-text">{formatDateWithTime(match.date)}</span>
                </div>

                <div className="match-teams">
                  <div className="team team--home">
                    <span className="team-name">{match.home_name}</span>
                  </div>

                  <div className="match-vs">
                    <span className="vs-text">vs</span>
                  </div>

                  <div className="team team--away">
                    <span className="team-name">{match.away_name}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Sección de partidos visitantes */}
      {awayCalendarData && awayCalendarData.length > 0 && (
        <div className="calendar-section" >
          <h3 className="calendar-section-title">Partidos {awayTeamName}</h3>
          <div className="calendar-content">
            {awayCalendarData.map((match) => (
              <div key={match.id_juego} className="calendar-match" onClick={() => openLink(match.opta_event_url, true)}>
                <div className="match-date">
                  <span className="date-text">{formatDateWithTime(match.date)}</span>
                </div>

                <div className="match-teams">
                  <div className="team team--home">
                    <span className="team-name">{match.home_name}</span>
                  </div>

                  <div className="match-vs">
                    <span className="vs-text">vs</span>
                  </div>

                  <div className="team team--away">
                    <span className="team-name">{match.away_name}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
